
<app-header></app-header>
<section style="margin-top:100px">

  <h2>Trading Contest</h2>
 </section>


 <div class="vote-section">
            <div class="container">
              <div class="vote-header">
                <h2>List Your <span>Token</span> with <span>Votes!</span></h2>
                <p> 
                  List your tokens on credbull exchange votes your community gives, the
                  lower your listing fee. Grab this golden chance, get your community
                  voting!
                </p>
                <button class="btn-primary" (mouseenter)="openPopUp()" (mouseleave)="closePopup()">
                  <i class="fas fa-info-circle"></i> About the Event
                </button>
              </div>
              <!-- <div class="vote-image">
                <img src="assets/images/votelg.webp" alt="Voting Image" class="light-theme">
                <img src="assets/images/votedk.webp" alt="Voting Image" class="dark-theme">
              </div> -->
            </div>




            <div class="tknLst-vote hlvnPg">
              <div class="container">
                <div class="row align-items-center">
                  <!-- Dynamic Heading Based on Active/Completed Toggle -->
                  <div class="col-lg-6">
                    <div class="tknLstTx">
                      <h1 class="lycStl cursor-pointer" (click)="showActiveTokens = true">
                        {{ showActiveTokens ? 'Active Tokens' : 'Completed Tokens' }}
                      </h1>
                    </div>
                  </div>
            
                  <!-- Toggle Button (View Active/Completed Tokens) -->
                  <div class="col-lg-6 text-right cursor-pointer">
                    <div class="evap-list d-flex align-items-center justify-content-end" (click)="showActiveTokens = !showActiveTokens">
                      <p class="viewdetail">
                        {{ showActiveTokens ? 'View Completed Tokens' : 'View Active Tokens' }}
                      </p>
                    
                    </div>
                  </div>
                </div>
            
              
              
                <div class="row mt-5 justify-content-center">
                  <ng-container *ngIf="showActiveTokens">
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-3" *ngFor="let token of activeTokens">
                      <div class="card token-card">
                        <div class="card-body">
                          <div class="token-header d-flex align-items-center">
                            <img [src]="token.image" class="token-image">
                            <div class="token-details">
                              <h5 class="token-name">{{ token.name }} <span class="token-symbol">{{ token.symbol }}</span></h5>
                            </div>
                          </div>
                          
                          <p class="token-description">{{ token.description }}</p>
                          <div class="token-info">
                            <div><strong>Total Supply:</strong> {{ token.totalSupply }}</div>
                            <div><strong>Starting Date:</strong> {{ token.startDate }}</div>
                            <div><strong>Ending Date:</strong> {{ token.endDate }}</div>
                          </div>
                          <hr>
                          <div class="token-footer d-flex justify-content-between align-items-center">
                            <span class="token-votes">{{ token.votes }} Votes</span>
                            <a class="btn btn-primary" href="/login">Login</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                
                  <ng-container *ngIf="!showActiveTokens">
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-3" *ngFor="let token of completedTokens">
                      <div class="card token-card">
                        <div class="card-body">
                          <div class="token-header d-flex align-items-center">
                            <img [src]="token.image" class="token-image">
                            <div class="token-details">
                              <h5 class="token-name">{{ token.name }} <span class="token-symbol">{{ token.symbol }}</span></h5>
                            </div>
                          </div>
                          <p class="token-description">{{ token.description }}</p>
                          <div class="token-info">
                            <div><strong>Total Supply:</strong> {{ token.totalSupply }}</div>
                            <div><strong>Starting Date:</strong> {{ token.startDate }}</div>
                            <div><strong>Ending Date:</strong> {{ token.endDate }}</div>
                          </div>
                          <hr>
                          <div class="token-footer d-flex justify-content-between align-items-center">
                            <span class="token-votes">{{ token.votes }} Votes</span>
                            <a class="btn btn-primary" href="/login">Login</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                
              </div>
            </div>
            
               
            <div class="faq-section container">
              <h2>FAQs</h2>
              <div class="faq">
                <div class="faq-item" (click)="toggleFAQ(1)">
                  <h3>How to Participate?</h3>
                  <p *ngIf="activeFAQ === 1">
                    Sign up, choose your token, and vote to reduce the listing fee!
                  </p>
                </div>
                <div class="faq-item" (click)="toggleFAQ(2)">
                  <h3>How Projects Benefit?</h3>
                  <p *ngIf="activeFAQ === 2">
                    Projects gain visibility, community engagement, and credibility.
                  </p>
                </div>
                <div class="faq-item" (click)="toggleFAQ(3)">
                  <h3>Why Choose credbull exchange?</h3>
                  <p *ngIf="activeFAQ === 3">
                    We provide marketing, development support, and premium tools.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div class="popup" *ngIf="popUp">
            <div class="popup-content">
                <span class="close" (click)="closePopup()">&times;</span>
                <h3 style="color: black;">Terms & Conditions</h3>
                
                <div class="popup" *ngIf="popUp">
                    <div class="popup-content">
                      <span class="close" (click)="closePopup()">&times;</span>
                      <h3 style="color: black;">About the event</h3>
                      <ul style="color:black;text-align: justify;">
                        <li>1.Participants must complete KYC verification, and tokens must meet Credbull Exchange’s listing requirements to be eligible.</li>
                        <li>2.Each verified user can cast one vote per token, and all votes are final and non-transferable.</li>
                        <li>3.Listing fees will decrease based on the total valid votes received, according to predefined voting tiers.</li>
                        <li>4.Fraudulent activities, such as fake accounts or bot voting, will result in disqualification, and projects must ensure honest promotion.</li>
                        <li>5.Votes do not guarantee listing, as all tokens must pass Credbull Exchange’s internal compliance and review process.</li>
                        <li>6.Credbull Exchange reserves the right to modify, suspend, or terminate the voting process at its discretion.</li>
                      </ul>
                    </div>
                  </div>
                  
            </div>
        </div>


  <section style="margin-top:320px">
    <app-footer></app-footer>
</section>
